import { render, staticRenderFns } from "./fluxPoolAssign.vue?vue&type=template&id=452b3282&"
import script from "./fluxPoolAssign.vue?vue&type=script&lang=js&"
export * from "./fluxPoolAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports